import focusWithin from 'focus-within'

focusWithin(document, {
    attr: false,
    className: 'focus-within',
})
